import { render } from "./DeleteJobModal.vue?vue&type=template&id=0a75943b&scoped=true"
import script from "./DeleteJobModal.vue?vue&type=script&lang=js"
export * from "./DeleteJobModal.vue?vue&type=script&lang=js"

import "./DeleteJobModal.vue?vue&type=style&index=0&id=0a75943b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a75943b"]])

export default __exports__